import { http } from '@/http/http.js'
export default {
    //查询合同信息
    queryContractInfo(params) {
        return http.post("/web/contractManage/queryContractInfo", params)
    },
    //根据ID查询合同详情
    getContractById(params) {
        return http.post("/web/contractManage/getContractById", params)
    },
    //作废合同
    cancelContractInfo(params) {
        return http.post("/web/contractManage/cancelContractInfo", params)
    },
    //修改合同信息
    updateContractInfo(params) {
        return http.post("/web/contractManage/updateContractInfo", params)
    },
    //新增合同信息
    addContractInfo(params) {
        return http.post("/web/contractManage/addContractInfo", params)
    }
}